import { createSelector } from 'reselect';

export const getAllErrors = state => state.error.get('records');

export const getTopNonAcknowledgedError = createSelector(
    [getAllErrors],
    allErrors => {
        return allErrors?.find(error => !error.isAcknowledged);
    }
);

export const isAPIErrored = state => state.error.get('isAPIErrored');
